export const isMobileUserAgent = (userAgent) => {
    return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
};

// 移动端断点
export const MOBILE_BREAK_POINT = 768;

// 获取设备类型
export const getDeviceType = (userAgent, width = null) => {
    if (typeof window === 'undefined') {
        // 服务端渲染时，只通过 UA 判断
        return isMobileUserAgent(userAgent) ? 'mobile' : 'desktop';
    }
    
    // 客户端渲染时，结合 UA 和屏幕宽度判断
    return isMobileUserAgent(userAgent) || (width && width <= MOBILE_BREAK_POINT) ? 'mobile' : 'desktop';
}; 